import { UPDATE_ADDRESS_STATUS_SUCCESS, UPDATE_ADDRESS_STATUS_REQUEST, UPDATE_ADDRESS_STATUS_FAILURE, UPDATE_ADDRESS_STATUS_RESET } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateAddressStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ADDRESS_STATUS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPDATE_ADDRESS_STATUS_REQUEST:
            return Object.assign({}, state);
        case UPDATE_ADDRESS_STATUS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPDATE_ADDRESS_STATUS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default updateAddressStatusReducer;
